import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { MsdAiService } from './services/msd-ai.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [MsdAiService],
})
export class MsdAiModule {
  static forRoot(): ModuleWithProviders<MsdAiModule> {
    return {
      ngModule: MsdAiModule,
      providers: [{ provide: MsdAiService }],
    };
  }
}
